import { PaymentsWorkspace } from '@/components/payments/payments-workspace'

export function OperationsPayments() {
  return <PaymentsWorkspace billingPath="/operations/billing" />
}
